import Vue from 'vue'
import Vuex from 'vuex'
import usermenu from '../config/usermenu'

Vue.use(Vuex)
let userinfo = JSON.parse(localStorage.getItem('userinfo')) || {}
const store = new Vuex.Store({
    state: {
        usermenu: usermenu,
        menuright: 'admin',
        usermenuActive: '',
        userinfo: userinfo,
        hasnew: true,
        unread: 0
    },
    getters: {
        getUserinfo(state) {
            return state.userinfo
        },
        usermenuActive(state) {
            return state.usermenuActive
        },
        hasnew(state) {
            return state.hasnew
        }
    },
    mutations: {
        setMenu(state, route) {
            if (state.userinfo.typeCode) {
                var typeCode = state.userinfo.typeCode.toLowerCase()
                state.menuright = typeCode
            }
            state.usermenu.forEach((item, index) => {
                if (item.path === route.path) {
                    state.usermenuActive = item.name
                }
                if (route.path.indexOf(item.active) > -1) {
                    state.usermenuActive = item.name
                }
            })
        },
        setUserinfo(state, data) {
            state.userinfo = JSON.parse(JSON.stringify(Object.assign(state.userinfo, data)))
        },
        hasnew(state, news) {
            state.hasnew = news
        },
        setunread(state, news) {
            state.unread = news
        }
    },
    actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js